export const QUESTION = `I've been feeling nervous, anxious or on edge over the last two weeks 2`
